<template>
    <v-menu :close-on-content-click="true">
        <template v-slot:activator="{ on, attrs }">
            <v-btn v-bind="attrs" v-on="on" icon x-small class="white--text">
                <v-icon>mdi-dots-horizontal</v-icon>
            </v-btn>
        </template>

        <v-list nav dense width="275">
            <v-list-item @click="toggleEnableScreenSharing()">
                <v-list-item-title>Enable Screensharing</v-list-item-title>
            </v-list-item>
            <v-subheader>Change Role for {{peer.name}}</v-subheader>
            <v-divider></v-divider>
            <v-list-item-group v-model="change_role">
                <v-list-item value="host">
                    <v-list-item-title>Host</v-list-item-title>
                </v-list-item>
                <v-list-item value="coach">
                    <v-list-item-title>Coach</v-list-item-title>
                </v-list-item>
                <v-list-item value="guest">
                    <v-list-item-title>Guest</v-list-item-title>
                </v-list-item>
                <v-list-item value="waiting-room">
                    <v-list-item-title>Waiting Room</v-list-item-title>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item value="remove">
                    <v-list-item-title>Remove</v-list-item-title>
                </v-list-item>
            </v-list-item-group>
        </v-list>
    </v-menu>
</template>

<script>
import { useMeetingStore } from '../stores/meeting'
import { selectPeerMetadata } from '@100mslive/hms-video-store'

export default {
    name: 'MeetingParticipantMenu',
    props: ['peer'],
    data: function() {
        return {
            meeting: null,
            change_role: null
        }
    },
    created: function() {
        this.meeting = useMeetingStore()
    },
    methods: {
        toggleEnableScreenSharing: async function() {
            const metadata = this.meeting.hmsStore.getState(selectPeerMetadata(this.meeting.local_peer.id))
            const enabled = metadata.isScreenSharingEnabled && metadata.isScreenSharingEnabled[this.peer.id] ? !metadata.isScreenSharingEnabled[this.peer.id] : true
            const newMetadata = { ...metadata, isScreenSharingEnabled: { [this.peer.id]: enabled } };
            await this.meeting.hmsActions.changeMetadata(newMetadata);
            await this.meeting.hmsActions.change
        }
    },
    watch: {
        'change_role': function(newV) {
            if(newV == 'remove') {
                const reason = 'Good Bye'
                this.meeting.hmsActions.removePeer(this.peer.id, reason)
            } else {
                this.meeting.hmsActions.changeRole(this.peer.id, newV, true);
            }
        }
    }
}
</script>
